module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "editKPIGroupDialog",
      "data-backdrop": "static",
      "data-keyboard": "false"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('form', {
    attrs: {
      "id": "editKPIGroupDialogForm"
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-hidden": "true"
    }
  }, [_vm._v("\n            ×\n          ")]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.lang.KM4006))])]), _vm._v(" "), _c('p', [_c('b', [_vm._v(_vm._s(_vm.lang.KM4007) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedClient) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4027) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedKpiGroup) + "\n            "), _c('b', [_vm._v("/ " + _vm._s(_vm.lang.KM4010) + ":")]), _vm._v("\n            " + _vm._s(_vm.nameOfSelectedEvaluationRuleGuid) + "\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "panel panel-default"
  }, [_c('div', {
    staticClass: "panel-body"
  }, [_c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-left": "0"
    }
  }, [_c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filterKpiGroupString),
      expression: "filterKpiGroupString"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "search",
      "placeholder": _vm.lang.KM4013
    },
    domProps: {
      "value": (_vm.filterKpiGroupString)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.filterKpiGroupString = $event.target.value
      }, function($event) {
        return _vm.doFilterKpiGroups()
      }],
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        $event.preventDefault();
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group searchbar col-md-6",
    staticStyle: {
      "padding-left": "15px",
      "top": "9px"
    }
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "disabled": _vm.feature.isAudiTarget &&
        _vm.feature.isEnabled('audi_importers')
    },
    on: {
      "change": function($event) {
        _vm.createNewKpiGroup(), _vm.getKpiGroupsOfSelectedClient()
      }
    },
    model: {
      value: (_vm.selectedClientGuid),
      callback: function($$v) {
        _vm.selectedClientGuid = $$v
      },
      expression: "selectedClientGuid"
    }
  }, _vm._l((_vm.clientList), function(client) {
    return _c('option', {
      key: client.ClientGuid,
      domProps: {
        "value": client.ClientGuid
      }
    }, [_vm._v("\n                      " + _vm._s(client.ClientName) + "\n                    ")])
  }), 0)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-container",
    staticStyle: {
      "clear": "both"
    }
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4036) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "25%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + "\n                        ")]), _vm._v(" "), _c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "55%"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + "\n                        ")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.filteredKpiGroups), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupGuid,
      class: {
        info: _vm.selectedKpiGroupGuid === kpiGroup.KPIGroupGuid,
      },
      attrs: {
        "role": "button"
      },
      on: {
        "click": function($event) {
          (_vm.selectedKpiGroupGuid = kpiGroup.KPIGroupGuid),
          _vm.getSelectedKpiGroupInformation()
        }
      }
    }, [_c('td', {
      staticStyle: {
        "width": "20%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupPosition) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "25%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupCode) + "\n                        ")]), _vm._v(" "), _c('td', {
      staticStyle: {
        "width": "55%"
      }
    }, [_vm._v("\n                          " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                        ")])])
  }), 0)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6",
    staticStyle: {
      "padding-right": "0"
    }
  }, [_c('ul', {
    staticClass: "nav nav-tabs nav-kpi-group-edit",
    staticStyle: {
      "margin-bottom": "15px"
    }
  }, [_c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#editKpiGroupTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'editKpiGroupTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4014))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4017))])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "#kpiGroupOrderTab",
      "data-toggle": "tab"
    },
    on: {
      "click": function($event) {
        (_vm.selectedTab = 'kpiGroupOrderTab'), _vm.getKpiGroupData()
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4037))])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade active in",
    attrs: {
      "id": "editKpiGroupTab"
    }
  }, [_c('form', {
    staticClass: "form-horizontal"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupCode",
      "id": "inputKpiGroupCodeLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4000) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectedKpiGroupInformation.KPIGroupCode),
      expression: "selectedKpiGroupInformation.KPIGroupCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupCode",
      "required": ""
    },
    domProps: {
      "value": (_vm.selectedKpiGroupInformation.KPIGroupCode)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupCode", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupCode')),
      expression: "inputHasError('inputKpiGroupCode')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupCodeLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4032))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupShortText",
      "id": "inputKpiGroupShortTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4001) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupShortText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "50",
      "id": "inputKpiGroupShortText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupShortText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupShortText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupShortText')),
      expression: "inputHasError('inputKpiGroupShortText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupShortTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4033))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupLongText",
      "id": "inputKpiGroupLongTextLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4004) + " *\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupLongText\n                            "
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "maxlength": "200",
      "id": "inputKpiGroupLongText",
      "required": ""
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupLongText
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupLongText", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inputHasError('inputKpiGroupLongText')),
      expression: "inputHasError('inputKpiGroupLongText')"
    }],
    staticClass: "help-block error text-danger"
  }, [_vm._v(_vm._s(_vm.lang.KM4029))])]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "inputKpiGroupLongTextLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4034))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupWeightInput",
      "id": "KPIGroupWeightInputLabel"
    }
  }, [_vm._v("\n                          " + _vm._s(_vm.lang.KM4031) + "\n                          "), _c('i', {
    staticClass: "material-icons md-18"
  }, [_vm._v("help_outline")])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.number",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      ),
      expression: "\n                              selectedKpiGroupInformation.KPIGroupWeight\n                            ",
      modifiers: {
        "number": true
      }
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "id": "KPIGroupWeightInput",
      "min": "0",
      "max": "100",
      "step": "0.01"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupWeight
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupWeight", _vm._n($event.target.value))
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }],
      "blur": function($event) {
        return _vm.$forceUpdate()
      }
    }
  })]), _vm._v(" "), _c('b-tooltip', {
    ref: "tooltip",
    attrs: {
      "target": "KPIGroupWeightInputLabel",
      "placement": "right",
      "delay": _vm.globals.tooltipDelay
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4035))])], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupProjectSelect"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4008) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupProjectSelect",
      "placeholder": _vm.lang.KM4009,
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiGroupDirty = true
      }
    },
    model: {
      value: (_vm.selectedProjectGuid),
      callback: function($$v) {
        _vm.selectedProjectGuid = $$v
      },
      expression: "selectedProjectGuid"
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.clientProjectList), function(project) {
    return _c('option', {
      key: project.ProjectGuid,
      domProps: {
        "value": project.ProjectGuid
      }
    }, [_vm._v("\n                              " + _vm._s(project.ProjectName) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "KPIGroupsSelectEvaluation"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4010) + " *")]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('select2', {
    staticClass: "form-control",
    attrs: {
      "id": "KPIGroupsSelectEvaluation",
      "placeholder": _vm.lang.KM4011,
      "required": ""
    },
    on: {
      "change": function($event) {
        _vm.selectedKpiGroupDirty = true
      }
    },
    model: {
      value: (
        _vm.selectedKpiGroupInformation.KPIEvaluationRuleGuid
      ),
      callback: function($$v) {
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIEvaluationRuleGuid", $$v)
      },
      expression: "\n                              selectedKpiGroupInformation.KPIEvaluationRuleGuid\n                            "
    }
  }, [_c('option'), _vm._v(" "), _vm._l((_vm.kpiGroupEvaluationRulesList), function(evaluation) {
    return _c('option', {
      key: evaluation.EvaluationRuleGuid,
      domProps: {
        "value": evaluation.EvaluationRuleGuid
      }
    }, [_vm._v("\n                              " + _vm._s(evaluation.EvaluationRule) + "\n                            ")])
  })], 2)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "col-md-3 control-label",
    attrs: {
      "for": "inputKpiGroupDescription"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4005))]), _vm._v(" "), _c('div', {
    staticClass: "col-md-9"
  }, [_c('div', {
    staticClass: "form-group nopadding"
  }, [_c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      ),
      expression: "\n                                selectedKpiGroupInformation.KPIGroupDescription\n                              "
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "3",
      "type": "text",
      "maxlength": "500",
      "id": "inputKpiGroupDescription"
    },
    domProps: {
      "value": (
        _vm.selectedKpiGroupInformation.KPIGroupDescription
      )
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.selectedKpiGroupInformation, "KPIGroupDescription", $event.target.value)
      }, function($event) {
        _vm.selectedKpiGroupDirty = true
      }]
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin": "25px 0 25px 0"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger",
      "dismissible": "",
      "show": _vm.showAlert
    },
    on: {
      "dismissed": function($event) {
        _vm.showAlert = false
      }
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4028))])], 1), _vm._v(" "), _c('div', [_c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.createNewKpiGroup()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("add_box")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4015) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    class: {
      'btn-warning': _vm.selectedKpiGroupDirty
    },
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid && !_vm.selectedKpiGroupDirty
    },
    on: {
      "click": function($event) {
        return _vm.validateBeforeSubmit('editKPIGroupDialog')
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("save")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4003) + "\n                      ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-top-bar",
    attrs: {
      "type": "button",
      "disabled": !_vm.selectedKpiGroupGuid
    },
    on: {
      "click": function($event) {
        return _vm.openDeleteKpiGroupConfirmationDialog()
      }
    }
  }, [_c('i', {
    staticClass: "material-icons md-36"
  }, [_vm._v("delete")]), _vm._v(" "), _c('br'), _vm._v("\n                        " + _vm._s(_vm.lang.KM4016) + "\n                      ")])])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4018) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4019))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi) {
    return _c('tr', {
      key: kpi.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpi.KPIShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpi.KPIGroupPosition),
        expression: "kpi.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpi, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpisInKpiGroup(),
            (_vm.changeKpiOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpisOfSelectedKpiGroup), function(kpi2) {
      return _c('option', {
        key: kpi2.KPIGroupPosition,
        domProps: {
          "value": kpi2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpi2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpisOfSelectedKpiGroup.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpisNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade",
    attrs: {
      "id": "kpiGroupOrderTab"
    }
  }, [_c('div', {
    staticClass: "table-container table-positions"
  }, [_c('table', {
    staticClass: "table table-striped table-hover"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "text-center",
    staticStyle: {
      "width": "80%"
    }
  }, [_vm._v("\n                              " + _vm._s(_vm.lang.KM4038) + "\n                            ")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "20%"
    }
  }, [_vm._v(_vm._s(_vm.lang.KM4039))])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup) {
    return _c('tr', {
      key: kpiGroup.KPIGroupPosition
    }, [_c('td', {
      staticStyle: {
        "width": "80%"
      }
    }, [_vm._v("\n                              " + _vm._s(kpiGroup.KPIGroupShortText) + "\n                            ")]), _vm._v(" "), _c('td', {
      staticClass: "nopadding"
    }, [_c('div', {
      staticClass: "form-group nopadding",
      staticStyle: {
        "width": "60%",
        "float": "left"
      }
    }, [_c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (kpiGroup.KPIGroupPosition),
        expression: "kpiGroup.KPIGroupPosition"
      }],
      staticClass: "form-control text-center nopadding",
      on: {
        "change": [function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(kpiGroup, "KPIGroupPosition", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }, function($event) {
          _vm.reorderKpiGroups(),
            (_vm.changeKpiGroupOrderDirty = true)
        }]
      }
    }, _vm._l((_vm.kpiGroupsOfSelectedClient), function(kpiGroup2) {
      return _c('option', {
        key: kpiGroup2.KPIGroupPosition,
        domProps: {
          "value": kpiGroup2.KPIGroupPosition
        }
      }, [_vm._v("\n                                    " + _vm._s(kpiGroup2.KPIGroupPosition) + "\n                                  ")])
    }), 0)])])])
  }), 0)])]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-raised btn-default",
    class: {
      'btn-warning': _vm.changeKpiGroupOrderDirty
    },
    attrs: {
      "type": "button",
      "disabled": _vm.kpiGroupsOfSelectedClient.length < 1
    },
    on: {
      "click": function($event) {
        return _vm.saveKpiGroupsNewOrder()
      }
    }
  }, [_vm._v("\n                      " + _vm._s(_vm.lang.KM4030) + "\n                    ")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-raised btn-default",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n            " + _vm._s(_vm.lang.KM4002) + "\n          ")])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5e184e","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/KPIManagement/KPIGroupEditModal.vue
// module id = 1671
// module chunks = 1